import React from 'react'

import { hot } from 'react-hot-loader'

import { ConnectedRouter } from 'connected-react-router'
import { Redirect, Route, Switch } from 'react-router-dom'
import { SecureRoute, ImplicitCallback } from '@okta/okta-react'

import { ToastContainer } from 'react-toastify'
import Sub_id from './submissions/Sub_id';

import Helmet from 'react-helmet'

import AppInitializer from './AppInitializer'
import OktaSecurity from './OktaSecurity'

import Header from './components/Header'
import Alert from './layout/containers/Alert'
import Footer from './layout/components/Footer'

import UserManagement from './routes/UserManagement'
import RequestAccess from './routes/SignUp/View/RequestAccess'
import { Brokerages, BrokerageDetail } from './brokerages'
import { ExternalLogin } from './components/Login'

import Login from './auth/components/Login'
import Signup from './auth/components/Signup'
import Logintrouble from './auth/components/Logintrouble'
import FAQ from './auth/components/FAQ'

import ForgotPassword from './auth/components/ForgotPassword'
import CompleteInvite from './auth/containers/CompleteInvite'

import ResetPassword from './auth/containers/ResetPassword'
import CompleteProfile from './auth/containers/CompleteProfile'

import { SubmissionsHomeContainer } from './submissions'

import Form from './routes/Form'
import FormResults from './routes/FormResults'

import { ClearanceContainer } from './clearance'
import PassClearance from './routes/PassClearance'
import FailClearance from './routes/FailClearance'

import ZigiZone from './routes/ZigiZone'

import withMustCompleteProfile from './auth/components/withUserMustCompleteProfile'

import { history } from './store'

import SiteMaintainance from '../app/siteMaintainance'

import routes from './constants/routes'

/** @todo Clean up this whole Helmet/content thing */
const titleTemplate = `Owner's Edge | %s`;
const meta = [{ name: 'description', content: 'A digitized submission portal' }, { property: 'og:type', content: 'site' }]

const App = ({maintainance}) => (
  maintainance ? <SiteMaintainance /> :
  <AppInitializer>
    <ConnectedRouter history={history}>
      <OktaSecurity>
        <div className="app">
          <div className="wrapper">
            <Helmet titleTemplate={titleTemplate} meta={meta} />
            <Header />
            <ToastContainer />
            <Alert />

            <Switch>
              <Route path={routes.ROOT} exact render={() => <Redirect to={routes.SUBMISSIONS} />} />

              <Route path={routes.IMPLICIT_CALLBACK} component={ImplicitCallback} />

              <Route path={routes.TOKEN} component={ExternalLogin} /> {/*  DEPRECATED. NO TIME TO REPLACE. */}

              <Route path={routes.LOGIN} component={Login} />
              <Route path={routes.SIGNUP} component={Signup} />
              <Route path={routes.LOGIN_TROUBLE} component={Logintrouble} />

              <Route path={routes.FAQ} component={FAQ} />
              <Route path={routes.GET_PDF} component={withMustCompleteProfile(Sub_id)} />

              <Route path={routes.REQUEST_ACCESS} component={RequestAccess} />

              <Route path={routes.FORGOT_PASSWORD} component={ForgotPassword} />
              <Route path={routes.RESET_PASSWORD} component={ResetPassword} />

              <Route path={routes.COMPLETE_INVITE} component={CompleteInvite} />
              <SecureRoute path={routes.COMPLETE_PROFILE} component={CompleteProfile} />

              <SecureRoute path={routes.USERS} component={withMustCompleteProfile(UserManagement)} />

              <SecureRoute path={routes.BROKERAGE} component={withMustCompleteProfile(BrokerageDetail)} />
              <SecureRoute path={routes.BROKERAGES} component={withMustCompleteProfile(Brokerages)} />

              <SecureRoute path={routes.CLEARANCE} component={withMustCompleteProfile(ClearanceContainer)} />

              <SecureRoute path={routes.SUBMISSIONS} component={withMustCompleteProfile(SubmissionsHomeContainer)} />
              <SecureRoute path={routes.SUBMISSION} component={withMustCompleteProfile(Form)} />
              <SecureRoute path={routes.QUOTE} component={withMustCompleteProfile(FormResults)} />

              <Route path={routes.PASS_CLEARANCE} component={PassClearance} />
              <Route path={routes.FAIL_CLEARANCE} component={FailClearance} />

              <Redirect from={routes.SUBMISSION_LEGACY} to={routes.SUBMISSION} />
              <Redirect from={routes.QUOTE_LEGACY} to={routes.QUOTE} />

              <SecureRoute path={routes.ZIGIZONE} component={ZigiZone} />
            </Switch>
          </div>
          <Footer />
        </div>
      </OktaSecurity>
    </ConnectedRouter>
  </AppInitializer>
)

export default hot(module)(App)
